// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import Vuex from "vuex";
import App from "./App";
import router from "./router";

//注册elementUi
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
//ElementUI全局默认配置修改
ElementUI.Dialog.props.closeOnClickModal.default = false;
ElementUI.Input.props.showWordLimit.default = true;
Vue.use(ElementUI);

//引入vant
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);
//全局图片预览
import { ImagePreview } from 'vant';
Vue.prototype.ImagePreview = ImagePreview;

//引入api配置文件
import globalAPI from '@/plugin/api';
Vue.prototype.globalAPI = globalAPI;

//全局选项
Vue.prototype.ABC = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

//全局缓存登录用户信息
Vue.use(Vuex);
const store = new Vuex.Store({
    state: {
        userInfoSession: JSON.parse(localStorage.getItem("userInfoSession")),
    },
    mutations: {
        setUserInfoSession(state) {
            state.userInfoSession = JSON.parse(localStorage.getItem("userInfoSession"));
            Vue.prototype.userInfoSession = state.userInfoSession;
        }
    }
});
Vue.prototype.userInfoSession = store.state.userInfoSession;

if (!Vue.prototype.userInfoSession) {
    console.log('未登录');
    router.push({
        path: "/Login",
        query: {}
    });
};

//全局请求配置
//不传token的接口
var noToken = [globalAPI.mainApi + 'syscaptcha/getVerifyCode', globalAPI.mainApi + 'stu/login/stuUserLogin', globalAPI.mainApi + 'stu/login/addStuLogin', globalAPI.mainApi + 'stu/login/forgetPassWord'];
//配置可以拦截请求的参数
var sourceCancel = axios.CancelToken.source();

//全局设置axios配置
var loading;
var requestCount = 0;
import axios from "axios";
import qs from "qs";
Vue.prototype.axios = axios;
Vue.prototype.qs = qs;
axios.interceptors.request.use(
    config => {
        if (Vue.prototype.userInfoSession && Vue.prototype.userInfoSession.accessToken) {
            let token = Vue.prototype.userInfoSession.accessToken;
            if (noToken.indexOf(config.url) < 0) {
                //全局插入Token
                config.headers.Authorization = token;
                config.cancelToken = sourceCancel.token;
            }
        }

        //全局loading
        requestCount++;
        loading = ElementUI.Loading.service({
            lock: true,
            text: '数据加载中……',
            spinner: 'el-icon-loading',
            background: 'rgba(255, 255, 255, 0.2)',
            customClass: 'overallLoading'
        });

        return config;
    },
    err => {
        requestCount--;
        if (loading && requestCount <= 0) {
            loading.close();
        }
        return Promise.reject(err);
    }
);

//校验token过期逻辑
var isRefresh;

axios.interceptors.response.use(function (response) {
    requestCount--;
    if (loading && requestCount <= 0) {
        loading.close();
    }

    //校验token过期时间
    var outUrl = noToken.indexOf(response.config.url) < 0 ? true : false;
    var outTime = Vue.prototype.userInfoSession && Vue.prototype.userInfoSession.expirationTime - response.data.timestamp <= (10 * 60 * 1000) ? true : false;
    if (outUrl && outTime && !isRefresh) {
        //不再刷新token
        return response;
        isRefresh = true;
        var url = globalAPI.mainApi + 'sys/ssaLogin/userRefresh';
        var postData = {
            data: {
                loginId: Vue.prototype.userInfoSession.staffId
            }
        };
        axios
            .post(url, postData)
            .then(function (res) {
                if (res.data.code == 1) {
                    var userInfoSession = JSON.parse(localStorage.getItem("userInfoSession"));
                    userInfoSession.accessToken = res.data.data.accessToken;
                    userInfoSession.expirationTime = res.data.data.expirationTime;
                    userInfoSession.expiresDate = res.data.data.expiresDate;
                    userInfoSession.refreshToken = res.data.data.refreshToken;
                    localStorage.setItem(
                        'userInfoSession',
                        JSON.stringify(userInfoSession)
                    );
                    Vuex.$store.commit('setUserInfoSession');
                }
                isRefresh = false;
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    //校验token过期时间

    // 对响应数据做点什么
    return response;
}, function (error) {
    requestCount--;
    if (loading && requestCount <= 0) {
        loading.close();
    }
    // 对响应错误做点什么
    if (error.response.status == 401) {
        Vue.prototype.$dialog.alert({
            message:'登录授权过期，请重新登录',
            theme: 'round-button',
        }).then(() => {
            localStorage.clear();
            router.push({
                path: "/Login",
                query: {}
            });
            return false;
        });
        //取消后边所有请求
        sourceCancel.cancel();
        sourceCancel = axios.CancelToken.source();
    }
    return Promise.reject(error);
});

//引入公共函数
import commonFn from '@/plugin/commonFn';
Vue.prototype.commonFn = commonFn;

router.beforeEach((to, from, next) => {
    if (to.matched.length === 0) {
        next({
            path: '/Login'
        });
    } else {
        next();
    }
})

//控制台打印
console.log("%c" + "Author：snow-fire \nQQ：http://wpa.qq.com/msgrd?v=3&uin=359120381&site=qq&menu=yes", "color:#409eff;font-size:1em;");

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    el: "#app",
    router,
    store,
    components: {
        App
    },
    template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js